/**
 * Join path segments with proper slash handling
 * @param {...string} segments - Path segments to join
 * @returns {string} Joined path
 */
export default (...segments) => segments
  .filter((segment) => segment !== null && segment !== undefined)
  .map((segment) => segment.replace(/^\/+|\/+$/g, ''))
  .join('/')
